import React from 'react';
import { IIcon } from '../interfaces';

function Search({ onClick, type, color, className, styles }: IIcon.Props) {

    return (
        <i className={`fa${type ? type?.substr(0,1) : "s"} fa-search ${className ?? ""} text-${color}`} onClick={onClick} style={styles}> </i>
    )
}

export default Search;